import React from 'react';

interface ButtonProps {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'danger';
  onClick?: (e: React.MouseEvent) => void;
  className?: string;
  disabled?: boolean;
  loading?: boolean;
  fullWidth?: boolean;
  /** Подпись для экранного диктора: кнопке из одной иконки текста не хватает */
  'aria-label'?: string;
  type?: 'button' | 'submit';
}

export const Button: React.FC<ButtonProps> = ({
  children,
  variant = 'primary',
  onClick,
  className = '',
  disabled = false,
  loading = false,
  fullWidth = false,
  'aria-label': ariaLabel,
  type = 'button',
}) => {
  const handleClick = (e: React.MouseEvent) => {
    if (disabled || loading) return;

    try {
      window.Telegram?.WebApp?.HapticFeedback?.impactOccurred('light');
    } catch {}

    onClick?.(e);
  };

  const getVariantStyles = () => {
    switch (variant) {
      case 'primary':
        return {
          backgroundColor: 'var(--accent)',
          color: '#FFFFFF',
          border: 'none',
        };
      case 'secondary':
        return {
          backgroundColor: 'transparent',
          color: 'var(--accent)',
          border: '1px solid var(--accent)',
        };
      case 'danger':
        return {
          backgroundColor: 'var(--danger)',
          color: '#FFFFFF',
          border: 'none',
        };
      default:
        return {};
    }
  };

  const baseClasses = `
    h-[50px] rounded-xl text-[17px] font-semibold px-6
    flex items-center justify-center
    transition-opacity
    ${fullWidth ? 'w-full' : ''}
    ${disabled || loading ? 'opacity-50 pointer-events-none' : 'active:opacity-80 cursor-pointer'}
    ${className}
  `.trim().replace(/\s+/g, ' ');

  return (
    <button
      type={type}
      aria-label={ariaLabel}
      className={baseClasses}
      style={getVariantStyles()}
      onClick={handleClick}
      disabled={disabled || loading}
    >
      {loading ? (
        <svg
          className="animate-spin h-5 w-5"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="4"
          />
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          />
        </svg>
      ) : (
        children
      )}
    </button>
  );
};
